var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-container"},[_c('v-container',[_c('ServicePlaceHeader',{attrs:{"service-place-id":parseInt(_vm.$route.params.id)}})],1),_c('v-container',{attrs:{"fluid":""}},[_c('ServicePlaceServicesList',{attrs:{"service-place-id":parseInt(_vm.$route.params.id)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }